import { StyleSheet } from '../../../../../../components/Common/react-native-components';

const reviewRatingStyling = () => {
  return StyleSheet.create({
    selectedMetrixContainer: {
      borderWidth: 1,
      borderRadius: 20,
      paddingVertical: 6,
      paddingHorizontal: 15,
      width: 250,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      marginLeft: 60
    }
  });
};

export { reviewRatingStyling };
